import * as swal from "sweetalert";
import * as _ from "lodash";
export class UserDetailModalComponent implements ng.IComponentOptions {
  public controller: any = UserDetailModalController;
  public bindings: any = {
    modalInstance: "<",
    resolve: "<"
  }
  public template: string =
    `<div class="modal-header">
      <button type="button" class="close" ng-click="$ctrl.cancel()" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      <h4 class="modal-title" id="userModal">User Details</h4>
    </div>
    <div class="modal-body">
      <form name="userForm" class="form-horizontal">
        <div class="form-group">
          <label for="fullName" class="col-sm-4 control-label">Full Name</label>
          <div class="col-sm-8 padding-top-7">
          {{$ctrl.user.fullname}}
          </div>
        </div>
        <div class="form-group">
          <label for="email" class="col-sm-4 control-label">Email</label>
          <div class="col-sm-8 padding-top-7">
          {{$ctrl.user.email}}
          </div>
        </div>
        <div class="form-group">
          <label for="contact" class="col-sm-4 control-label">Contact No</label>
          <div class="col-sm-8 padding-top-7">
          {{$ctrl.user.contact}}
          </div>
        </div>
        <div class="form-group" ng-show="$ctrl.user.usertype == 'external'">
          <label for="contact" class="col-sm-4 control-label">User Type</label>
          <div class="col-sm-8 padding-top-7">
          {{$ctrl.user.category}}
          </div>
        </div>
        <div class="form-group" ng-show="$ctrl.user.usertype == 'external_org'">
          <label for="contact" class="col-sm-4 control-label">Organisation Name</label>
          <div class="col-sm-8 padding-top-7">
          {{$ctrl.user.organization.name}}
          </div>
        </div>
        <div class="form-group" ng-show="$ctrl.user.usertype == 'external_org'">
          <label for="contact" class="col-sm-4 control-label">Organisation Type</label>
          <div class="col-sm-8 padding-top-7">
          {{$ctrl.user.organization.org_type}}
          </div>
        </div>
        <div class="form-group">
          <label for="contact" class="col-sm-4 control-label">Purpose</label>
          <div class="col-sm-8 padding-top-7">
          {{$ctrl.user.purpose}}
          </div>
        </div>
        <div class="form-group">
          <label for="contact" class="col-sm-4 control-label">Rejection Reason</label>
          <div class="col-sm-8 padding-top-7">
          {{$ctrl.user.rejectionReason.reason.name}}
          </div>
        </div>
        <div class="form-group">
          <label for="contact" class="col-sm-4 control-label">Rejection Notes</label>
          <div class="col-sm-8 padding-top-7">
          {{$ctrl.user.rejectionReason.notes}}
          </div>
        </div>
        <div class="form-group">
          <label for="contact" class="col-sm-4 control-label">Created On</label>
          <div class="col-sm-8 padding-top-7">
          {{$ctrl.user.createdOn}}
          </div>
        </div>

      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default" ng-click="$ctrl.cancel()">Close</button>
    </div>`;
}
export interface IUser extends ng.resource.IResource<any> {

}
export class UserDetailModalController {
  public static $inject: Array<string> = ["$timeout"]
  public modalInstance: ng.ui.bootstrap.IModalServiceInstance;
  public resolve: any;
  public user:any;
  constructor(private $timeout: ng.ITimeoutService){
    $timeout(() => {
      this.user = this.resolve.user;
    })
  }
  public cancel() {
    this.modalInstance.dismiss("canceled");
  }

}
